module.exports = __webpack_public_path__ + "static/media/nav2_tw_hover.d82f697e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nav2_tw_hover.png
// module id = 240
// module chunks = 0